// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import AppAdvantages from '@justpark/ui/src/components/AppAdvantages';
import AppIcons from '@justpark/ui/src/components/AppIcons';
import AppExample from '@justpark/ui/src/components/AppExample';
import BrandTypography from '@justpark/ui/src/components/BrandTypography';

import styles from '../../../static/scss/components/landing/appBenefits.module.scss';

const AppBenefits = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <BrandTypography level={2} bold>
        The simplest way to park
      </BrandTypography>
      <AppAdvantages
        firstHeading={t('homePage:headingCloser', 'Get closer')}
        firstText={t(
          'homePage:textCloser',
          'With over 100k spaces available to book, including driveways, you’ll always be a stone’s throw away from where you need to be.'
        )}
        secondHeading={t('homePage:headingSmarter', 'Park smarter')}
        secondText={t(
          'homePage:textSmarter',
          'Save time, money & hassle by booking your space before you set out.'
        )}
        thirdHeading={t('homePage:headingPeace', 'Peace of mind')}
        thirdText={t(
          'homePage:textPeace',
          'Find the best spot, see exactly what you’re paying & even extend your stay - all through our award-winning app.'
        )}
      />

      <AppIcons />

      <AppExample />
    </div>
  );
};

export default AppBenefits;
